import { render, staticRenderFns } from "./HeiOrganization.vue?vue&type=template&id=36e18303&scoped=true&"
import script from "./HeiOrganization.vue?vue&type=script&lang=js&"
export * from "./HeiOrganization.vue?vue&type=script&lang=js&"
import style0 from "./HeiOrganization.vue?vue&type=style&index=0&id=36e18303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e18303",
  null
  
)

export default component.exports